// Booking status constants
export const BOOKING_STATUS = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

// Booking status options for dropdowns
export const BOOKING_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: BOOKING_STATUS.PENDING, label: "Pending" },
  { value: BOOKING_STATUS.CONFIRMED, label: "Confirmed" },
  { value: BOOKING_STATUS.COMPLETED, label: "Completed" },
  { value: BOOKING_STATUS.CANCELLED, label: "Cancelled" },
];

// Membership levels
export const MEMBERSHIP_LEVELS = {
  REGULAR: "REGULAR",
  SILVER: "SILVER",
  GOLD: "GOLD",
  PLATINUM: "PLATINUM",
};

export const MEMBERSHIP_LEVEL_OPTIONS = [
  { value: "", label: "All Levels" },
  { value: MEMBERSHIP_LEVELS.REGULAR, label: "Regular" },
  { value: MEMBERSHIP_LEVELS.SILVER, label: "Silver" },
  { value: MEMBERSHIP_LEVELS.GOLD, label: "Gold" },
  { value: MEMBERSHIP_LEVELS.PLATINUM, label: "Platinum" },
];

// Table status
export const TABLE_STATUS = {
  AVAILABLE: "AVAILABLE",
  IN_SERVICE: "IN_SERVICE",
  OUT_OF_SERVICE: "OUT_OF_SERVICE",
};

// Table configuration
export const TABLE_CONFIG = {
  DEFAULT_ITEMS_PER_PAGE: 10,
  ITEMS_PER_PAGE_OPTIONS: [5, 10, 20, 50],
  MAX_VISIBLE_PAGES: 5,
};

// Modal modes
export const MODAL_MODES = {
  VIEW: "view",
  EDIT: "edit",
  DELETE: "delete",
};

// Reference social media
export const SOCIAL_MEDIA = {
  FACEBOOK:
    "https://www.facebook.com/people/Pho-1986-Sushi-Restaurant-Vietk%C3%BCche/61581615716574/?al_applink_data=%7B%22qpl_join_id%22%3A%22803F9E4D-5B3A-44F7-A23B-B176F6365760%22%7D&from_xma_click=xma_e2ee&xma_click_id=A7ED4389-2C67-4C91-94E5-211044E60846&tam_xma_content_type=3000&is_fb_content=true&forward=false&ts=1760178433332",
  INSTAGRAM: "https://www.instagram.com/pho_1986_lohkamp46_langenhagen/",
  TIKTOK: "https://www.tiktok.com/@pho1986.langenhagen?_t=ZS-90SSnnWyfXb&_r=1",
};
